import { z } from 'zod';

import { TestAssetStatusFilterSchema } from '@/features/stacktrace/qa-force/test-assets/-constants';

export const TestAssetListPageFilterSchema = z.object({
  status: TestAssetStatusFilterSchema.catch('ALL').default('ALL'),
  productId: z.string().optional(),
  freeText: z.string().optional(),
  isArchived: z.coerce.boolean().default(false),
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
});
